<template>

	<div class="container">

		<!-- 페이지 타이틀 -->
		<div class="page-title">
			<h2 class="tit">{{ courseVO.title }}</h2>
		</div>

		<!-- 리스트 -->
		<div class="learning-title">
			<div class="inner">
				<div class="thumb-box" v-if="courseVO.thumbnail != null && courseVO.thumbnail !== ''" :style="'background-image: url(' + courseVO.thumbnail + ');'"></div>
				<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
				<div class="text-box">
					<div class="cate bedge-line">
						<span class="prim" v-if="courseVO.cateCodeVO != null">{{ courseVO.cateCodeVO.codeName }}</span>
						<span class="sec" >{{ courseVO.shortTitle }}</span>
					</div>
					<h2 class="tit">{{ courseVO.title }}</h2>
					<div class="info">
						<div class="info-row">
							<strong>학습기간</strong>
							<div>
								<template v-if="!$options.filters.isEmpty(courseVO.startDate)">
									{{ courseVO.startDate | scheduleFilter( courseVO.scheduleMode ) }}
								</template>
								-
								<template v-if="!$options.filters.isEmpty(courseVO.endDate)">
									{{ courseVO.endDate | scheduleFilter( courseVO.scheduleMode ) }}
								</template>
								<!--2021.06.21 10:00 - 2022.12.31 23:59-->
							</div>
						</div>
						<!--<div class="info-row">
							<strong>필수이수시간</strong>
							<div>135시간</div>
						</div>-->
						<div class="info-row" v-if="!$options.filters.isEmpty(courseVO.teacherName)">
							<strong>강사</strong>
							<div>{{ courseVO.teacherName }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list-content">
			<ul class="type-webzine">

				<li v-for="(item, index) in courseVO.eduMainList">
					<!--<router-link :to="'/app/education/main/?mode=learn&emIdx=' + item.emIdx">-->
					<a href="javascript:;" @click="goEduMain(item);">
						<div class="num-box"><span>{{ index+1 }}</span></div>
						<div class="thumb-box" v-if="item.thumbnail != null && item.thumbnail !== ''" :style="'background-image: url(' + item.thumbnail + ');'"></div>
						<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
						<div class="text-box">
							<div class="cate bedge-line">
								<span class="prim" v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
								<span class="sec" v-if="item.isMajor">주요교육</span>
							</div>
							<h3 class="tit">
								{{ item.shortTitle }} {{ item.eduTitle }}
							</h3>
							<p class="desc">
								{{ item.introduce }}
							</p>
							<ul class="info">
								<li class="like"><span class="blind">좋아요</span>{{ item.wishCount }}</li>
								<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
							</ul>
						</div>
					</a>
				</li>

			</ul>
		</div>
		<div class="btn-area">
			<a href="javascript:;" class="btn-listgo" @click="goBackList">목록으로</a>
		</div>

	</div>

</template>

<script>
import Qs from "qs";

export default {
	name: "courseDetail",
	prop: {
		cidx: Number,
		eduCourse: Object,
	},
	data() {

		const userId = this.getLoginId()

		return {

			userId,

			cidx: this.$route.query.cidx,
			courseVO: new this.EduCourseVO(),
		}
	},
	created() {

		this.getCourseDetail( this.cidx, this.userId );

	},
	mounted() {

		//this.getWishLike( this.emIdx, this.userId );

	},
	updated() {

	},
	methods: {



		getCourseDetail: function (_cidx, _userId) {

			var self = this

			self.$eventBus.$emit("startProgress")
			this.axiosCaller.get(this, this.APIs.EDU_COURSE + "/", {
				cidx : _cidx,
				userId : _userId,
			}, function (res) {
				self.$eventBus.$emit("doneProgress")

				const result = res.data
				console.log(result)
				if ( result.status === "ok" && result.list.length > 0 ) {
					self.courseVO = result.list[0];
				}
				//console.log("allContentCnt ::::: " + self.allContentCnt)
			})

		},


		goEduMain ( _item ) {

			this.$router.push({
				path: '/app/education/main/',
				query: {
					mode: "learn",
					emIdx: _item.emIdx,
					cateCode: _item.cateCode,
				},
			},).catch((e) => {
				console.log(e)
			})

		},


		goBackList(e) {
			history.back();
		},



	}
}
</script>

<style scoped>

</style>
